import React,{ useState } from "react";
import { useDispatch } from "react-redux";
import { exportTasks } from "actions";
import Filter from "../Filter";
import { Excel } from "CommonComponent";

const Header = ({onFilter, extraFiltersState, setExtraFiltersState, handleExport}) => {
  const [showAddNewModal, setShowAddNewModal] = useState(false);

  const handleOpenModal = () => setShowAddNewModal(true);
  const handleCloseModal = () => setShowAddNewModal(false);

  return (
    <>
      <div className="z-1">
        <div className="d-flex justify-content-between align-items-center p-4">
          <h1 className="font-24 font-weight-s-bold m-0">Monthly ACD</h1>
          <div className="d-flex gap-3">
            <Excel handleExport={handleExport} />
            
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
